/**
 * Single source of truth for the public-facing PAID pricing tiers that appear in
 * SEO structured data (the SoftwareApplication `offers` array in seoHelpers.ts).
 *
 * Plain TS — no React, no i18n — so it is safe to import from SSG prerender and
 * from plain node/tsx build scripts (the check-pricing-schema guard imports the
 * SAME list and asserts the emitted schema names match, so they can never drift
 * again). The prior hardcoded names (Lite/Standard/Premium at €2/€5/€10) went
 * stale after the 2026-06-26 tier rename and shipped to 215 prerendered pages —
 * the one rich result that actually renders (REVIEW_SNIPPET) was showing Google
 * defunct tier names. Keep in sync with PricingPage's live tiers.
 */
export interface PublicPricingTier {
  name: string;
  priceEur: string;
  sku: string;
}

export const PUBLIC_PRICING_TIERS: PublicPricingTier[] = [
  { name: 'Installer', priceEur: '5', sku: 'cctvplanner-installer-monthly' },
  { name: 'Business', priceEur: '10', sku: 'cctvplanner-business-monthly' },
  { name: 'Studio', priceEur: '19', sku: 'cctvplanner-studio-monthly' },
  { name: 'Enterprise', priceEur: '150', sku: 'cctvplanner-enterprise-monthly' },
];

/** Retired display names that must NEVER reappear in structured data. */
export const RETIRED_TIER_NAMES = ['Lite', 'Standard', 'Premium', 'Pro'];
